import angular from 'angular'

import ggsUtils from '../utils'
import ggsFrame from '../ggs-frame'
import ggsAnimate from '../ggs-animate'
import ggsSpinner from '../ggs-spinner'

export default angular
  .module('ggs.gallery-vote-frame', [
    ggsUtils,
    ggsFrame,
    ggsAnimate,
    ggsSpinner
  ])
  .name
